import { z } from 'zod';

export enum CREATE_CUSTOM_FIELD_FORM_FIELD {
	name = 'name',
	instruction = 'instruction',
	isChecked = 'isChecked',
}

export const CreateCustomFieldSchema = z.object({
	[CREATE_CUSTOM_FIELD_FORM_FIELD.name]: z.string().min(1, 'Field name is required'),
	[CREATE_CUSTOM_FIELD_FORM_FIELD.instruction]: z.string().optional(),
	[CREATE_CUSTOM_FIELD_FORM_FIELD.isChecked]: z.boolean(),
});

export type CreateCustomFieldDto = z.infer<typeof CreateCustomFieldSchema>;
